import React, { useEffect, useState } from "react"
import { Form, Input, Label, Row, Col, FormFeedback } from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import Spinners from "components/Common/Spinner"
import toast from "react-hot-toast"
import RenderBusinessType from "./renderBusinessType"
import { useStoreBusinessAdditionalDetailsProfileMutation } from "store/api/profile/profile.api"
import { businessTypes, showRegistrationType } from "helpers/common"
import { useSelector } from "react-redux"
import KycDocumentUpload from "pages/KYC/kycDocumentUpload"

const BusinessAdditionalDetails = ({ kycData, profileData }) => {
  const [mutate, { isLoading }] =
    useStoreBusinessAdditionalDetailsProfileMutation()
  const [businessType, setBusinessType] = useState()
  const [showGSTIN, setShowGSTIN] = useState(false)
  const [uploadPanCard, setUploadPanCard] = useState(false)
  const { userType } = useSelector((state) => state.user)

  const storeDetails = async (body) => {
    try {
      const { success, message } = await mutate(body).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        window.location.reload()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      showGSTIN,
      politicalExposure: kycData?.businessAdditionalDetails?.politicalExposure,
      entity_registration_no:
        kycData?.businessAdditionalDetails?.entity_registration_no,
      constitution_of_business: businessType,
      initial_partnership_deed: "",
      latest_partnership_deed: "",
      certificate_of_incorporation: "",
      gstin_certificate: "",
      registration_certificate: "",
      memorandum_of_association: "",
      articles_of_association: "",
      initial_llp_deed: "",
      latest_llp_deed: "",
      // huf_creation_document: "",
      trust_deed: "",
      society_bye_laws: "",
      pan_image: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      const { pan_image, ...rest } = values
      storeDetails(uploadPanCard ? values : rest)
    },
  })

  const politicalExposeOptions = [
    "Not Applicable",
    "Politically Exposed Person",
    "Related to Politically Exposed Person",
  ]

  useEffect(() => {
    if (kycData) {
      const type =
        profileData?.companyDetails.constitution_of_business ||
        kycData?.businessAdditionalDetails?.constitution_of_business ||
        "Private Limited Company"
      setBusinessType(type)
      const isExists = !kycData?.investorCompanyDetails?.gst_waiver
      setShowGSTIN(isExists)
    }
  }, [kycData])

  useEffect(() => {
    if (kycData && profileData) {
      if (profileData?.companyDetails.entity_name !== kycData?.name) {
        setUploadPanCard(true)
      }
    }
  }, [kycData, profileData])

  return (
    <>
      <div className="bank-details-wrapper">
        <h5 className="title mb-3">Additional Details</h5>
        <p>
          These details are required for registration of{" "}
          {userType === "INVESTOR" ? "an investor" : "a Wealth Partner"}
        </p>
        <Form
          onSubmit={(e) => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <Row className="mb-2">
            <Col xl={12}>
              <Label className="col-form-label">
                Political Exposure <span className="error">*</span>
              </Label>
              <select
                id="politicalExposure"
                name="politicalExposure"
                className={`form-select pageSize ${
                  validation.touched.politicalExposure &&
                  validation.errors.politicalExposure &&
                  "is-invalid"
                }`}
                value={validation.values.politicalExposure}
                onChange={validation.handleChange}
              >
                <option value="">Select</option>
                {politicalExposeOptions.map((item, index) => (
                  <option key={`political_exposure_${index}`} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              {validation.touched.politicalExposure &&
              validation.errors.politicalExposure ? (
                <FormFeedback type="invalid">
                  {validation.errors.politicalExposure}
                </FormFeedback>
              ) : null}
            </Col>
            <Col xl={12}>
              <Label className="col-form-label">
                {`Entity Registration No.${
                  showRegistrationType(businessType)?.trim()
                    ? ` (${showRegistrationType(businessType)})`
                    : ""
                }`}
                <span className="error">*</span>
              </Label>
              <Input
                name="entity_registration_no"
                type="text"
                className="form-control"
                id="horizontal-firstname-Input"
                placeholder={`Enter Entity Registration No.`}
                value={validation.values.entity_registration_no}
                onChange={validation.handleChange}
                invalid={
                  validation.touched.entity_registration_no &&
                  validation.errors.entity_registration_no
                }
              />
              {validation.touched.entity_registration_no &&
              validation.errors.entity_registration_no ? (
                <FormFeedback type="invalid">
                  {validation.errors.entity_registration_no}
                </FormFeedback>
              ) : null}
            </Col>

            <Col xl={12}>
              <Label className="col-form-label">
                Constitution of Business
                <span className="error">*</span>
              </Label>
              <select
                id="constitution_of_business"
                disabled
                name="constitution_of_business"
                className={`form-select pageSize ${
                  validation.touched.constitution_of_business &&
                  validation.errors.constitution_of_business &&
                  "is-invalid"
                }`}
                value={validation.values.constitution_of_business}
                onChange={validation.handleChange}
              >
                <option value={"item"}>Select</option>
                {businessTypes(userType).map((item, index) => (
                  <option
                    key={`constitution_of_business_${index}`}
                    value={item}
                  >
                    {item}
                  </option>
                ))}
              </select>
              {validation.touched.constitution_of_business &&
              validation.errors.constitution_of_business ? (
                <FormFeedback type="invalid">
                  {validation.errors.constitution_of_business}
                </FormFeedback>
              ) : null}
            </Col>

            {validation.values.constitution_of_business !==
              "Hindu Undivided Family" && (
              <Row>
                <div className="charter-documents-wrapper">
                  <h5>Charter Documents</h5>
                  <p>Upload Required Charter Documents</p>
                </div>
              </Row>
            )}

            <RenderBusinessType
              type={validation.values.constitution_of_business}
              validation={validation}
              kycData={kycData}
              preview={true}
            />
            {uploadPanCard && (
              <Col xl={12}>
                <Label className="col-form-label">
                  PAN <span className="error">*</span>
                </Label>
                <KycDocumentUpload
                  fieldKey={"pan_image"}
                  validation={validation}
                  extensionAllowedInput=".jpg,.jpeg,.png"
                  extensionAllowed={[
                    "image/jpeg",
                    "image/png",
                    "application/pdf",
                  ]}
                  typeError={"Please upload file in PDF format only."}
                  preview={true}
                />
              </Col>
            )}

            <Col sm={12}>
              <div className="d-flex align-items-center mt-4">
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={isLoading}
                >
                  {isLoading ? <Spinners /> : "Proceed"}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  )
}

export default BusinessAdditionalDetails
